export default "__VITE_ASSET__Dg$5AQNZ__"